// Models
import { MultipleDaysOrDatesRecurrenceCalculator } from "./MultipleDaysOrDatesRecurrenceCalculator";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Represents a monthly recurrence pattern calculator.
 * @example 2nd of every other month. (MonthlyFixed)
 * @example Last Tuesday of every 4th month. (MonthlyFloating)
 */ export class MonthlyRecurrenceCalculator extends MultipleDaysOrDatesRecurrenceCalculator {
    isSameOrBefore(start, end) {
        // Set to beginning of the month then check. This is because we iterate through the months
        return Temporal.PlainDate.compare(start.with({
            day: 1
        }), end.with({
            day: 1
        })) <= 0;
    }
    getDurationBetweenDateAndPatternStartDate(date) {
        // Set to beginning of month and return number of whole months between the given date and the pattern start date.
        return date.with({
            day: 1
        }).since(this.patternStartDate.with({
            day: 1
        }), {
            largestUnit: "months"
        }).months;
    }
    constructor(schedule, patternStartDateAsInstant, occurrenceIndex){
        super(schedule, patternStartDateAsInstant, occurrenceIndex, {
            months: 1
        });
    }
}
